import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { UsageReportingData, UsageReportingService } from './usage-reporting.service';

@Injectable()
export class UsageReportingResolver {
  constructor(private UsageReportingService: UsageReportingService) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resolve(route: ActivatedRouteSnapshot): Observable<UsageReportingData | null> {
    return this.UsageReportingService.getUsageReporting();
  }
}
